import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { DeleteAccountDialogModule } from '@libs/src/delete-account-dialog/delete-account-dialog.module';
import { DialogConfirmPromptModule } from '@libs/src/dialog-confirm-prompt/dialog-confirm-prompt.module';
import { ToastModule } from '@libs/src/toast/toast.module';
import { AccountEditDialogModule } from '@main-client/src/app/account-edit-dialog/account-edit-dialog.module';
import { AccountEditDrawerModule } from '@main-client/src/app/account-edit-drawer/account-edit-drawer.module';
import { AccountHubsEditModule } from '@main-client/src/app/account/account-hubs-edit.module';
import { AccountFullNamePipeModule } from '@main-client/src/app/pipes/account-full-name-pipe/account-full-name-pipe.module';
import { GroupMembershipPipeModule } from '@main-client/src/app/pipes/group-membership-pipe/group-membership-pipe.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';
import { TtcMatPaginatorModule } from '@main-client/src/app/ttc-mat-paginator/ttc-mat-paginator.module';

import { AdminBackend } from '@libs/src/admin/admin.backend';

import { MembersTableComponent } from './members-table.component';

@NgModule({
  imports: [
    AccountEditDrawerModule,
    AccountEditDialogModule,
    AvatarModule,
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatTableModule,
    RouterModule.forChild([]),
    GroupMembershipPipeModule,
    DeleteAccountDialogModule,
    ToastModule,
    AccountHubsEditModule,
    MatDividerModule,
    DialogConfirmPromptModule,
    TtcMatPaginatorModule,
    AccountFullNamePipeModule,
    TranslationLookupModule,
  ],
  exports: [MembersTableComponent],
  declarations: [MembersTableComponent],
  providers: [AdminBackend],
})
export class MembersTableModule {}
